import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const mark = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <Layout>
      <div className="fade-in space-y-4">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <h1 className="text-2xl font-semibold tracking-tight" style={{fontFamily:'Outfit'}}>Notifications</h1>
          <Button variant="outline" onClick={markAll} data-testid="mark-all-read-btn"><CheckCheck className="h-4 w-4 mr-1"/> Mark all read</Button>
        </div>
        <Card className="rounded-xl border-slate-200">
          <CardContent className="p-0">
            {items.length === 0 ? (
              <div className="px-6 py-10 text-center text-slate-500" data-testid="no-notifications">You have no notifications.</div>
            ) : (
              <ul>
                {items.map((n) => (
                  <li key={n.id} className={`px-6 py-4 border-b last:border-b-0 border-slate-100 flex items-start gap-3 ${n.read ? "bg-white" : "bg-blue-50/30"}`} data-testid={`notif-${n.id}`}>
                    <div className="h-8 w-8 rounded-full bg-blue-50 text-blue-900 grid place-items-center mt-0.5"><Bell className="h-4 w-4"/></div>
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-slate-900">{n.title}</div>
                      <div className="text-sm text-slate-600">{n.body}</div>
                      <div className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                    </div>
                    {!n.read && <Button size="sm" variant="ghost" onClick={() => mark(n.id)} data-testid={`mark-read-${n.id}`}>Mark read</Button>}
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
